<app-clientdetails-card></app-clientdetails-card>
<app-clientheadquaterdetails-list></app-clientheadquaterdetails-list>
<!--<app-clientdetails-listsearch></app-clientdetails-listsearch>-->
